
import { Building2 } from "lucide-react";
import { CompanySection } from "@/components/company/CompanySection";
import { useProfileData } from "@/hooks/useProfileData";
import { Button } from "@/components/ui/button";
import { Loader2, Save } from "lucide-react";
import PageLayout from "@/components/layout/PageLayout";
import { useTranslation } from "react-i18next";
import { useToast } from "@/hooks/use-toast";

const CompanyInformation = () => {
  const { profile, setProfile, loading, saving, saveProfile } = useProfileData();
  const { t } = useTranslation("profile");
  const { toast } = useToast();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  const handleSave = async () => {
    try {
      await saveProfile(profile);
      toast({
        title: t("successMessage"),
        description: t("successDescription"),
      });
    } catch (error) {
      toast({
        title: t("errorMessage"),
        description: t("errorDescription"),
        variant: "destructive",
      });
    }
  };

  return (
    <PageLayout
      title={t("companySection.title")}
      description={t("companySection.description")}
      icon={<Building2 className="h-6 w-6" />}
    >
      <div className="container mx-auto py-8 px-4 animate-fade-up">
        <div className="border-2 border-primary/20 rounded-lg p-6">
          <CompanySection
            companyName={profile.company_name}
            notificationEmail={profile.notification_email}
            onCompanyNameChange={(value) => {
              setProfile({ ...profile, company_name: value });
            }}
            onNotificationEmailChange={(value) => {
              setProfile({ ...profile, notification_email: value });
            }}
          />
        </div>

        <div className="flex justify-end pt-4">
          <Button
            onClick={handleSave}
            disabled={saving}
            className="flex items-center gap-2 px-6"
          >
            {saving ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Save className="h-4 w-4" />
            )}
            {saving ? t("savingChanges") : t("saveChanges")}
          </Button>
        </div>
      </div>
    </PageLayout>
  );
};

export default CompanyInformation;
